import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmPopoverModule } from '~shared/modules/popover/popover.module';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { RegionSelectorComponent } from '~shared/modules/region-selector/components/region-selector/region-selector.component';

@NgModule({
  declarations: [RegionSelectorComponent],
  exports: [RegionSelectorComponent],
  imports: [
    CommonModule,
    MmPopoverModule,
    MmButtonModule,
    TranslateModule,
    MmFlexLayoutModule,
    MmIconModule,
    QaLocatorsModule,
  ],
})
export class RegionSelectorModule {}
